import React, { useEffect } from "react";
import {
  Container,
  CustomInput,
  EndLabel,
  HelperText,
  InputContainer,
  Label,
} from "./styles";

export default function TextInput({
  name,
  label,
  placeholder,
  type,
  endLabel,
  value,
  onChange,
  helperText,
  errorMessage = '',
  fullWidth = false,
  maxLength,
  ...props
}) {
  return (
    <Container fullWidth={fullWidth}>
      <Label htmlFor={name}>{label}</Label>
      <InputContainer>
        <CustomInput
          name={name}
          placeholder={placeholder}
          type={type}
          value={value}
          onChange={onChange}
          maxLength={maxLength}
          {...props}
        />
        {endLabel && <EndLabel>{endLabel}</EndLabel>}
      </InputContainer>
      {maxLength && <HelperText>{value?.length || 0}/{maxLength}</HelperText>}
      {helperText && !errorMessage && <HelperText>{helperText}</HelperText>}
      {!!errorMessage && <HelperText isError={!!errorMessage}>{errorMessage}</HelperText>}
    </Container>
  );
}
